<template>
    <div class="wrapper" v-if="isShow">
        <div class="header-layer">部分优质项目展示</div>
<!--         <div class="menu-layer">
            <div class="menu-item" :class="{'active': item.id == curUnitId}" v-for="item in areas" @click="selectUnit(item)">{{item.name}}</div>            
        </div> -->
        <div class="city-layer">
            <div class="city-item" v-for="item in showlist" @click="goPage(item)">
                <img :src="item.src" />
            </div>
        </div>
    </div>
</template>
<script>
import util from "@/utils/utils";
import * as comreq from "@/utils/comreq";  
import { MessageBox } from 'mint-ui';
import wxsdk from "@/utils/wxsdk";
import Cookies from "js-cookie";
export default {
    components: {},    
    data() {
        return {
            isShow: true,
            areas: [{
                id: 1,
                list: [{
                    url: 'http://lsst.abotz.com/h5/t9?id=141389&psn=06e8b5a4d3e94db1a62671eefd40ef0e',
                    src: 'https://assets.rurushishi.com//yq-rs-make/sysintro/pic_1.png'
                },{
                    url: 'http://lsst.abotz.com/h5/t9?id=139842&psn=1506af3ff83044c1a71250a80049e5e5',
                    src: 'https://assets.rurushishi.com//yq-rs-make/sysintro/pic_2.png'
                },{
                    url: 'http://njshy.okjedi.com/h5/t9?id=141425&psn=f6648808f39a4d77ac1c9320429dab62',
                    src: 'https://assets.rurushishi.com//yq-rs-make/sysintro/pic_3.png'
                },{
                    url: 'http://lsdyb.gdsmcc.com/h5/t9?id=139852&psn=20d8f0010f5341fe86ab29abb16f4501',
                    src: 'https://assets.rurushishi.com//yq-rs-make/sysintro/pic_4.png'
                },{
                    url: 'http://lfblg.gbtse.com/h5/t9?id=139808&psn=70de85032efc413d81a954e1d5842c32',
                    src: 'https://assets.rurushishi.com//yq-rs-make/sysintro/pic_5.png'
                },{
                    url: 'http://lfblg.gbtse.com/h5/t9?id=140885&psn=ced7c5c1eb2644a1944bb82b92db9d53',
                    src: 'https://assets.rurushishi.com//yq-rs-make/sysintro/pic_6.png'
                },{
                    url: 'http://lsdyb.gdsmcc.com/h5/t9?id=140918&psn=9297695f6a18464c94e93f774b018c38',
                    src: 'https://assets.rurushishi.com//yq-rs-make/sysintro/pic_7.png'
                },{
                    url: 'http://njshy.okjedi.com/h5/t9?id=138830&psn=14714064185d4658b1af4a6e7c01a9ca',
                    src: 'https://assets.rurushishi.com//yq-rs-make/sysintro/pic_8.png'
                },{
                    url: 'http://lsdyb.gdsmcc.com/h5/t9?id=143111&psn=d34501c490e645d7af58dd452db7719a',
                    src: 'https://assets.rurushishi.com//yq-rs-make/sysintro/pic_9.png'
                },{
                    url: 'http://lsst.abotz.com/h5/t9?id=143127&psn=b9cfc4a2d0664cad82925fbc009b0dd2',
                    src: 'https://assets.rurushishi.com//yq-rs-make/sysintro/pic_10.png'
                },{
                    url: 'http://lsst.abotz.com/h5/t9?id=143140&psn=6d10c66c10d949b786763e93aaeaa48f',
                    src: 'https://assets.rurushishi.com//yq-rs-make/sysintro/pic_11.png'
                },{
                    url: 'http://lsst.abotz.com/h5/t9?id=143148&psn=52b1330d6dd846fdaaad8bc3465f760c',
                    src: 'https://assets.rurushishi.com//yq-rs-make/sysintro/pic_12.png'
                },{
                    url: 'http://lsst.abotz.com/h5/t9?id=143121&psn=c6f42aeff1ec44d4b565e199e2766761',
                    src: 'https://assets.rurushishi.com//yq-rs-make/sysintro/pic_13.png'
                },{
                    url: 'http://njshy.okjedi.com/h5/t9?id=143427&psn=3effdf9638d94412b78c745351c36466',
                    src: 'https://assets.rurushishi.com//yq-rs-make/sysintro/pic_14.png'
                }]
            }],
            curUnitId: 1,
            showlist: []
        };
    },
    computed: {},
    watch: {},    
    filters: {},
    methods: {
        selectUnit(item) {
            let that = this
            if(item.id == that.curUnitId) return
            that.curUnitId = item.id
            that.setShowlist()
        },
        goPage(item) {
            let that = this
            if(item.url == '##') {
                MessageBox.alert("敬请期待");
            } else if(item.url == '####') {

            } else {
                window.location.href = `${item.url}`
            }
        },
        setShowlist() {
            let that = this;
            that.areas.forEach(e => {
                if(e.id == that.curUnitId) {
                    that.showlist = e.list
                }
            })
        }
    },
    mounted() {
        let that = this;
        that.setShowlist();
        //设置分享
        that.global.SHARE_TITLE = `蓝风线上售楼中心，看房咨询一步到位，最新购房优惠抢先看！`;
        that.global.SHARE_DESC = `美好人居，一触即达。帮忙传播，更有多重惊喜哟！`;
        that.global.SHARE_IMG_URL = 'https://assets.rurushishi.com//yq-rs-make/sysintro/sharelf.png';
        let shareLink = `${location.protocol}//${location.host}/h5/huafa/lfintro`;
        that.global.SHARE_LINK = shareLink;
        wxsdk.init();
    }
}
</script>
<style lang="stylus" scoped>
.wrapper {
    background-color: #efefef;
}
.header-layer {
    line-height: .8rem
    font-size: .32rem
    color: #333333
    font-weight: bold
    background: url('https://assets.rurushishi.com//yq-rs-make/sysintro/lf_logo.png') no-repeat left center;
    background-size: 1.9rem .35rem  
    padding-left: 2rem
    margin-left: .3rem  
}
.menu-layer {
    padding: 0 .3rem
    display: flex
    flex-wrap: wrap
}
.menu-layer .menu-item {
    width: 1.55rem
    height: .7rem
    border-radius: .6rem
    background-color: #F6F7F9
    font-size: .28rem
    color: #666666
    font-weight: bold
    margin-top: .2rem
    line-height: .7rem
    text-align: center
    margin-right: .15rem
}
.menu-layer .menu-item.active {
    color: #ffffff
    background: linear-gradient(to right, #D23F15, #FF8E8E);
}
.city-layer {
    padding: 0.2rem .3rem
}
.city-layer .city-item {
    width: 100%
    // height: 2rem
    margin-top: .2rem
}
.city-layer .city-item > img {
    display: block
    width: 100%
}
// .wrapper {
//     position: absolute;
//     left: 0;
//     top: 0;
//     bottom: 0;
//     right: 0;
//     overflow: hidden;
//     background-color: #efefef;
// }

// .header-layer > img{
//     width: 100%;
//     height: 2.18rem;
//     display: block;
// }

// .pannel-layer {
//     position: absolute;
//     left: 0;
//     top: 2.18rem;
//     bottom: 0;
//     right: 0;
//     overflow: hidden;
//     display: flex;
// }

// .pannel-layer .menu-layer {
//     width: 1.5rem
//     overflow-y: auto;
//     -webkit-overflow-scrolling: touch;
// }

// .pannel-layer .menu-layer .menu-item {
//     line-height: .8rem 
//     text-align: center 
//     font-size: .26rem
//     color: #212121
//     position: relative
// }

// .pannel-layer .menu-layer .menu-item.active {
//     color: #1995F4
//     background-color: #fff 
// }

// .pannel-layer .menu-layer .menu-item.active::after {
//     position: absolute
//     content: ''
//     top: 0
//     left: 0
//     bottom: 0
//     width: 8px
//     background-color: #1995F4
// }

// .pannel-layer .house-layer {
//     flex: 1
//     background-color: #fff
//     overflow-y: auto;
//     -webkit-overflow-scrolling: touch;
//     padding: 0 0.2rem
//     // margin-bottom: .88rem
//     // display: flex;
//     // flex-wrap: wrap;  
// }

// .pannel-layer .house-layer .house-item {
//     height: 2.5rem
//     text-align: center 
//     width: 2.5rem
//     line-height: .6rem
//     margin: .15rem
//     background-color: #efefef
//     display: inline-block 
// }

// .pannel-layer .house-layer .house-item > img {
//     width: 100%;
//     display: block;
// }
</style>